export default __webpack_public_path__ + "static/media/metalBrush.87d72323.png";